import React, { useState } from 'react';
import {
  Col, Row, Input, FormGroup, Label, Button,
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import templatesFonts from '../../fonts/templates-fonts';
import './templates.css';
import { fontIsDeprecated } from '../templates-manager/utils';

const Texts = ({
  addText,
  onChangeText,
  texts,
  removeText,
  previewsRef,
}) => {
  const [selectOpened, setSelectOpened] = useState([]);
  const toggleSelect = (index) => {
    const selectOpenedTmp = [...selectOpened];
    selectOpenedTmp[index] = !selectOpenedTmp[index];
    setSelectOpened(selectOpenedTmp);
  };

  const [presetWidthsOpened, setPresetWidthsOpened] = useState([]);
  const togglePresetWidthsSelect = (index) => {
    const presetWidthsOpenedTmp = [...presetWidthsOpened];
    presetWidthsOpenedTmp[index] = !presetWidthsOpenedTmp[index];
    setPresetWidthsOpened(presetWidthsOpenedTmp);
  };

  const [presetHorizontalAlignmentsOpened, setPresetHorizontalAlignmentsOpened] = useState([]);
  const toggleHorizontalAlignmentsSelect = (index) => {
    const presetHorizontalAlignmentsOpenedTmp = [...presetHorizontalAlignmentsOpened];
    presetHorizontalAlignmentsOpenedTmp[index] = !presetHorizontalAlignmentsOpenedTmp[index];
    setPresetHorizontalAlignmentsOpened(presetHorizontalAlignmentsOpenedTmp);
  };

  const [presetVerticalAlignmentsOpened, setPresetVerticalAlignmentsOpened] = useState([]);
  const toggleVerticalAlignmentsSelect = (index) => {
    const presetVerticalAlignmentsOpenedTmp = [...presetVerticalAlignmentsOpened];
    presetVerticalAlignmentsOpenedTmp[index] = !presetVerticalAlignmentsOpenedTmp[index];
    setPresetVerticalAlignmentsOpened(presetVerticalAlignmentsOpenedTmp);
  };

  const PRESET_WIDTHS = [
    {
      label: 'FULL WIDTH NO MARGIN (1280)',
      value: 1280,
    },
    {
      label: 'FULL WIDTH WITH MARGINS (1200)',
      value: 1200,
    },
    {
      label: 'MEDIUM WIDTH (800)',
      value: 800,
    },
    {
      label: 'HALF WIDTH (640)',
      value: 640,
    },
    {
      label: 'HALF WIDTH WITH MARGINS (620)',
      value: 620,
    },
  ];

  const HORIZONTAL_ALIGNMENTS = ['LEFT', 'CENTER', 'RIGHT', 'LEFT WITH MARGIN', 'RIGHT WITH MARGIN'];
  const VERTICAL_ALIGNMENTS = ['TOP', 'MIDDLE', 'BOTTOM', 'TOP WITH MARGIN', 'BOTTOM WITH MARGIN'];

  const formText = (item, index) => (
    <Row className="container_item_text" key={index}>
      <Col xs="auto" className="title_item_text">
        <span>{`Text ${index + 1}`}</span>
        <Button color="danger" size="sm" onClick={() => removeText(index)}>Delete</Button>
      </Col>
      <Col className="container_form_text">
        <Row className="section_form_text">
          <FormGroup>
            <Label for="text_fr">Français</Label>
            <Input type="textarea" name="text_fr" value={item.fr || item.defaultTextFr} onChange={(evt) => handleChange(evt.target.value, 'fr', index)} />
          </FormGroup>
          <FormGroup>
            <Label for="text_en">English</Label>
            <Input type="textarea" name="text_en" value={item.en || item.defaultTextEn} onChange={(evt) => handleChange(evt.target.value, 'en', index)} />
          </FormGroup>
        </Row>
        <Row className="section_form_text">
          <FormGroup>
            <Label for="x">x</Label>
            <Input type="number" name="x" min={0} value={item.x} onChange={(evt) => handleChange(evt.target.value, 'x', index, true)} />
          </FormGroup>
          <FormGroup>
            <Label for="y">y</Label>
            <Input type="number" name="y" min={0} value={item.y} onChange={(evt) => handleChange(evt.target.value, 'y', index, true)} />
          </FormGroup>
          <FormGroup>
            <Label for="width">width</Label>
            <Input type="number" name="width" min={1} value={item.width} onChange={(evt) => handleChange(evt.target.value, 'width', index, true)} />
          </FormGroup>
        </Row>
        <Row className="section_form_text">
          <FormGroup>
            <ButtonDropdown
              isOpen={presetHorizontalAlignmentsOpened[index]}
              toggle={() => toggleHorizontalAlignmentsSelect(index)}
            >
              <DropdownToggle color="info" style={{ fontFamily: item.fontFamily, marginLeft: 15 }} caret>
                Align X
              </DropdownToggle>
              <DropdownMenu style={{ height: 190, overflowY: 'scroll' }}>
                {HORIZONTAL_ALIGNMENTS.map((value) => (
                  <DropdownItem
                    key={value}
                    onClick={() => {
                      switch (value) {
                        case 'CENTER':
                          handleChange((1280 - item.width) / 2, 'x', index, true);
                          break;
                        case 'LEFT':
                          handleChange(0, 'x', index, true);
                          break;
                        case 'RIGHT':
                          handleChange(1280 - item.width, 'x', index, true);
                          break;
                        case 'LEFT WITH MARGIN':
                          handleChange(40, 'x', index, true);
                          break;
                        case 'RIGHT WITH MARGIN':
                          handleChange(1280 - item.width - 40, 'x', index, true);
                          break;
                        default:
                          break;
                      }
                    }}
                  >
                    {value}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </ButtonDropdown>
          </FormGroup>
          <FormGroup>
            <ButtonDropdown
              isOpen={presetVerticalAlignmentsOpened[index]}
              toggle={() => toggleVerticalAlignmentsSelect(index)}
            >
              <DropdownToggle color="info" style={{ fontFamily: item.fontFamily, marginLeft: 15 }} caret>
                Align Y
              </DropdownToggle>
              <DropdownMenu style={{ height: 190, overflowY: 'scroll' }}>
                {VERTICAL_ALIGNMENTS.map((value) => (
                  <DropdownItem
                    key={value}
                    onClick={async () => {
                      let textHeight = 0;
                      if (previewsRef && previewsRef.current) {
                        const frHeight = await previewsRef.current.getTextHeight('fr', index);
                        const enHeight = await previewsRef.current.getTextHeight('en', index);
                        textHeight = (frHeight + enHeight) / 2;
                      }
                      switch (value) {
                        case 'TOP':
                          handleChange(0, 'y', index, true);
                          break;
                        case 'MIDDLE':
                          handleChange(960 / 2 - textHeight / 2 - item.fontSize * 0.2, 'y', index, true);
                          break;
                        case 'BOTTOM':
                          handleChange(960 - textHeight - item.fontSize * 0.2, 'y', index, true);
                          break;
                        case 'TOP WITH MARGIN':
                          handleChange(40, 'y', index, true);
                          break;
                        case 'BOTTOM WITH MARGIN':
                          handleChange(960 - textHeight - 40 - item.fontSize * 0.2, 'y', index, true);
                          break;
                        default:
                          break;
                      }
                    }}
                  >
                    {value}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </ButtonDropdown>
          </FormGroup>
          <FormGroup>
            <ButtonDropdown
              isOpen={presetWidthsOpened[index]}
              toggle={() => togglePresetWidthsSelect(index)}
            >
              <DropdownToggle color="info" style={{ fontFamily: item.fontFamily, marginLeft: 15 }} caret>
                Preset widths
              </DropdownToggle>
              <DropdownMenu style={{ height: 190, overflowY: 'scroll' }}>
                {PRESET_WIDTHS.map(({ label, value }) => (
                  <DropdownItem key={value} onClick={() => handleChange(value, 'width', index, true)}>{label}</DropdownItem>
                ))}
              </DropdownMenu>
            </ButtonDropdown>
          </FormGroup>
        </Row>
        <Row className="section_form_text">
          <FormGroup>
            <Label for="fontFamily">font-family</Label>
            <ButtonDropdown isOpen={selectOpened[index]} toggle={() => toggleSelect(index)}>
              <DropdownToggle color="info" style={{ fontFamily: item.fontFamily, marginLeft: 15 }} caret>
                {item.fontFamily}
              </DropdownToggle>
              <DropdownMenu style={{ height: 300, overflowY: 'scroll' }}>
                {templatesFonts.map(({ fontFamily, name: fontName }) => (
                  <DropdownItem
                    key={fontName}
                    onClick={() => handleChange(fontFamily, 'fontFamily', index)}
                    style={{ fontFamily, ...(fontIsDeprecated(fontName) ? { opacity: 0.3 } : {}) }}
                  >
                    {fontName}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </ButtonDropdown>
          </FormGroup>
        </Row>
        <Row className="section_form_text">
          <FormGroup>
            <Label for="fontFamily">font-size</Label>
            <Input type="number" name="fontSize" min={1} value={item.fontSize} onChange={(evt) => handleChange(evt.target.value, 'fontSize', index, true)} />
          </FormGroup>
          <FormGroup>
            <Label for="x">color</Label>
            <Input type="color" name="color" value={item.color} onChange={(evt) => handleChange(evt.target.value, 'color', index)} />
          </FormGroup>
          <FormGroup>
            <Label for="rotate">rotation</Label>
            <Input type="number" name="rotate" min={0} max={360} value={item.rotate} onChange={(evt) => handleChange(evt.target.value, 'rotate', index, true)} />
          </FormGroup>
        </Row>
      </Col>
    </Row>
  );

  const handleChange = (value, key, index, isInt) => {
    let newText;
    if (value === '') {
      newText = null;
    } else if (isInt) {
      newText = parseInt(value, 10);
    } else {
      newText = value;
    }
    onChangeText(newText, key, index);
  };

  return (
    <Col className="section_form_template">
      <h4>Texts</h4>
      {texts && texts.map((item, index) => formText(item, index))}
      <Button color="primary" onClick={addText}>Add text</Button>
    </Col>
  );
};

export default Texts;



// WEBPACK FOOTER //
// ./src/components/templates/texts.js